"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getABIFor = void 0;
function getABIFor(abi, methodName) {
    return abi.find(({ name }) => name === methodName);
}
exports.getABIFor = getABIFor;
//# sourceMappingURL=abi.js.map